import { UserInfo } from '@/slw/shared/types/auth.type';

import {
  CheckEmailData,
  LoginData,
  LoginPayload,
  RegisterData,
  RegisterPayload,
  UpdatePasswordPayload,
  VerifyOtpPayload,
} from './auth.type';

/**
 * Get users with filtering and pagination
 */
export const getUsers = async (search: string) => {
  const pageResponse = await apiClient().get<UserInfo[]>('/ecom-users', { params: { SearchValue: search } });

  return pageResponse;
};

export async function checkEmail(email: string) {
  return apiClient().get<CheckEmailData>('/ecom-users/check-user-exist-by-email', { params: { email } });
}

export async function register(data: RegisterPayload) {
  return apiClient().post<RegisterData>('/ecom-users/register', data);
}

export async function login(data: LoginPayload) {
  return apiClient().post<LoginData>('/ecom-users/login', data);
}

export async function forgotPassword(email: string) {
  return apiClient().post<CheckEmailData>('/ecom-users/forgot-password', {}, { params: { email } });
}

export async function confirmOtpForForgotPassword(data: VerifyOtpPayload) {
  return apiClient().post<boolean>('/ecom-users/confirm-otp-for-forgot-password', {}, { params: data });
}

export async function verifyOtp(data: VerifyOtpPayload) {
  return apiClient().post<boolean>('/ecom-users/verify-otp', {}, { params: data });
}

export async function resendOtp(data: { email: string; sessionId: string }) {
  return apiClient().post<boolean>('/ecom-users/resend-otp', {}, { params: data });
}

export async function changePassword(data: UpdatePasswordPayload) {
  return apiClient().post<boolean>('/ecom-users/change-password-after-confirm-otp', {}, { params: data });
}
